import { createContext } from 'react';

export const DragPreviewContext = createContext<boolean>(false);
